// import axios from 'axios'
// import qs from 'qs'
// import { Message } from 'element-ui'
// // 1. 创建新的axios实例，
// const service = axios.create({
//   // 公共接口--这里注意后面会讲
//   // baseURL: 'http://192.168.161.143/', // 打包
//   baseURL: '', // 本地

//   // baseURL: axios.defaults.baseURL, // 本地
//   // 超时时间 单位是ms，这里设置了3s的超时时间
//   timeout: 30000,
//   // JavaScript对象，从服务器返回的JSON字符串解析
//   responseType: 'json'
// })
// // 2.请求拦截器
// // service.interceptors.request.use(config => {
// //   // 发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
// // //   config.headers = {
// // //     'Content-Type': 'application/x-www-form-urlencoded' // 配置请求头
// // //   }
// // //   let token = 'Bearer '
// // //   if (localStorage.getItem('token')) {
// // //     token = token + localStorage.getItem('token')
// // //     // config.params = { token: token } // 如果要求携带在参数中
// // //   } else {
// // //     token = token + 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjBmZTg5NDQ5LTc5ZmEtNGIzNy1iNTllLTA4ZmViN2YxNGI1YyJ9.JnkF-NIVcpJcouffwGk8HD7PFc6mlbGbNb5J5XVBlEx-MXcDjCi3bCQoWICT2qc9rDllLDzlfL_vgWFifgZxpA'
// // //     // token = token + 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImFhN2U0MDM2LWU4MWEtNGI1ZC04MTBjLTllNmEwYzhhNjJjMyJ9.DwmM5tYbTa8w_ai8dMhU8c3oVjtzH3e55PQM3Y9Oz6SkBfV4A1pwEUEd5T85aoTvzWE-ngqOV7xLqpzNOqBn2Q'
// // //     // config.params = { token: token } // 如果要求携带在参数中
// // //   }
// // //   config.headers.Authorization = token // 如果要求携带在请求头中
// //   return config
// // }, error => {
// //   Promise.reject(error)
// // })
// // 3.响应拦截器
// // service.interceptors.response.use(response => {
// //   // 接收到响应数据并成功后的一些共有的处理，关闭loading等
// //   // const param = response.data
// //   // if (param.ok === 4000 || param.code === 200 || param.code === 0) {
// //   //   return Promise.resolve(param)
// //   // }
// //   // else {
// //     // Message({
// //     //   showClose: true,
// //     //   message: param.msg,
// //     //   type: 'error'
// //     // })
// //     return Promise.reject(response.data)
// //   // }
// // }, error => {
// //   // /** *** 接收到异常响应的处理开始 *****/
// //   // if (error && error.response) {
// //   //   // 1.公共错误处理
// //   //   // 2.根据响应码具体处理
// //   //   switch (error.response.status) {
// //   //     case 400:
// //   //       error.message = '错误请求'
// //   //       break
// //   //     case 401:
// //   //       error.message = '未授权，请重新登录'
// //   //       break
// //   //     case 403:
// //   //       error.message = '拒绝访问'
// //   //       break
// //   //     case 404:
// //   //       error.message = '请求错误,未找到该资源'
// //   //       break
// //   //     case 405:
// //   //       error.message = '请求方法未允许'
// //   //       break
// //   //     case 408:
// //   //       error.message = '请求超时'
// //   //       break
// //   //     case 500:
// //   //       error.message = '服务器端出错'
// //   //       break
// //   //     case 501:
// //   //       error.message = '网络未实现'
// //   //       break
// //   //     case 502:
// //   //       error.message = '网络错误'
// //   //       break
// //   //     case 503:
// //   //       error.message = '服务不可用'
// //   //       break
// //   //     case 504:
// //   //       error.message = '网络超时'
// //   //       break
// //   //     case 505:
// //   //       error.message = 'http版本不支持该请求'
// //   //       break
// //   //     default:
// //   //       error.message = `连接错误${error.response.status}`
// //   //   }
// //   // } else {
// //   //   // 超时处理
// //   //   if (JSON.stringify(error).includes('timeout')) {
// //   //     Message({
// //   //       showClose: true,
// //   //       message: '服务器响应超时，请刷新当前页',
// //   //       type: 'error'
// //   //     })
// //   //   }
// //   //   error.message('连接服务器失败')
// //   // }
// //   // Message({
// //   //   showClose: true,
// //   //   message: error.message,
// //   //   type: 'error'
// //   // })
// //   // /** *** 处理结束 *****/
// //   // // 如果不需要错误处理，以上的处理过程都可省略
// //   return Promise.reject(error.response)
// // })
// // 4.导入文件
// export default function request (url, type = 'get', params = {}, baseApi) {
//   const urls = baseApi || ''

//   url = urls + url
//   // axios.defaults.baseURL = 'http://sjsy.bsedu.org.cn' + urls
//   // console.log(axios.defaults.baseURL)
//   const config = {
//     url: url,
//     method: type.toLowerCase()
//   }
//   switch (type.toLowerCase()) {
//     case 'get':
//       config.params = params
//       break
//     case 'post':
//       config.data = qs.stringify(params)
//       break
//     case 'delete':
//       config.data = qs.stringify(params)
//       break
//     case 'put':
//       config.data = qs.stringify(params)
//       break
//   }
//   return service(config)
// }
import axios from 'axios';

//1. 创建axios对象
const service = axios.create();

//2. 请求拦截器
service.interceptors.request.use(config => {
  // let token = this.$store.getters.saveUserData
  
  if (localStorage.getItem("token")) {
    // if (localStorage.token) {
    // 配置请求头
    config.headers = {
      // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'token': localStorage.getItem('token')
    };
  };
  return config;
}, error => {
  Promise.reject(error);
});

//3. 响应拦截器
service.interceptors.response.use(response => {
  //判断code码
  return response.data;
}, error => {
  return Promise.reject(error);
});
// export default function request (url, type = 'get', params = {}, baseApi) {
//   const urls = baseApi || ''

//   url = urls + url
//   // axios.defaults.baseURL = 'http://sjsy.bsedu.org.cn' + urls
//   // console.log(axios.defaults.baseURL)
//   const config = {
//     url: url,
//     method: type.toLowerCase()
//   }
//   switch (type.toLowerCase()) {
//     case 'get':
//       config.params = params
//       break
//     case 'post':
//       config.data = qs.stringify(params)
//       break
//     case 'delete':
//       config.data = qs.stringify(params)
//       break
//     case 'put':
//       config.data = qs.stringify(params)
//       break
//   }
//   return service(config)
// }
export default service;